import { useState } from "react";
import { X } from "lucide-react";

export default function AdWelcome({ onSelect }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  const options = [
    { key: "consultation", label: "1:1 Consultation", price: "₹3,000", testid: "ad-welcome-consultation" },
    { key: "transformation", label: "Transformation Journey", price: "₹25,000", testid: "ad-welcome-transformation" },
    { key: "ebook", label: "Mumma Can Heal Me", price: "₹188", testid: "ad-welcome-ebook" },
  ];

  return (
    <div className="fixed inset-x-3 bottom-3 z-[55] sm:left-auto sm:right-6 sm:bottom-6 sm:w-96" data-testid="ad-welcome">
      <div className="rounded-3xl bg-[#2F3B2E] text-white p-5 shadow-[0_25px_60px_-15px_rgba(35,43,34,0.7)] border border-[#C9B48A]/30">
        <button
          onClick={() => setVisible(false)}
          data-testid="ad-welcome-close"
          aria-label="Dismiss"
          className="absolute top-3.5 right-3.5 text-white/50 hover:text-white transition-colors"
        >
          <X size={17} />
        </button>
        <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#C9B48A]">Welcome from Instagram</p>
        <p className="mt-1.5 font-serif-display text-lg leading-snug">Jump straight to what you came for</p>
        <div className="mt-4 space-y-2">
          {options.map((o) => (
            <button
              key={o.key}
              onClick={() => { setVisible(false); onSelect(o.key); }}
              data-testid={o.testid}
              className="w-full flex items-center justify-between rounded-xl bg-white/10 hover:bg-white/20 px-4 py-3 text-sm font-medium transition-colors duration-200"
            >
              <span>{o.label}</span>
              <span className="text-[#C9B48A]">{o.price}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
